import React, {PureComponent} from "react"

import {Para} from "@irati/ui/src/Labels"
import {FormattedMessage} from "@irati/utils/lang"
import {H3} from "@irati/ui/src//Typography/Heading"
import Close from "@irati/ui/src/Close"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import tenantSetupTracking, {TenantSetupInterfaces, ResetModalClickedValues} from "@irati-tracking/tenant-setup"

import {ContentWrapper, CloseWrapper, WaitImageAbsolute, CustomModal} from "./styled"

interface Props {
  onHide: () => void,
  handleReset: () => void,
  show?: boolean,
  load?: Promise<any>
}

class LoseChangesModal extends PureComponent<Props> {
  componentDidMount() {
    tenantSetupTracking.viewResetChangesModal()
  }

  onClick = (clicked: ResetModalClickedValues) => {
    const {onHide, handleReset} = this.props
    const params: TenantSetupInterfaces.ResetModalParams = {clicked}
    tenantSetupTracking.resetChangesModalAction(params)
    if (clicked === ResetModalClickedValues.Ok) {
      handleReset()
    } else {
      onHide()
    }
  }

  render() {
    const {show, load} = this.props

    return (
      <CustomModal dialogClassName="custom-dialog" onHide={() => this.onClick(ResetModalClickedValues.Blur)} show={show}>
        <CloseWrapper>
          <WaitImageAbsolute sizeInPx={100} />
          <Close onClick={() => this.onClick(ResetModalClickedValues.Cross)} top="20px" right="20px" />
        </CloseWrapper>
        <ContentWrapper>
          <H3 small>
            <FormattedMessage id="setup_tenant.loseChangeModal.title" />
          </H3>
          <Para center>
            <FormattedMessage id="setup_tenant.loseChangeModal.body" />
          </Para>
          <br />
          <Para center>
            <FormattedMessage id="setup_tenant.loseChangeModal.body2" />
          </Para>
        </ContentWrapper>
        <Flex justifyContent="center" margin={2} alignItems="center">
          <Button tertiary onClick={() => this.onClick(ResetModalClickedValues.Cancel)} marginRight={2}>
            <FormattedMessage id="setup_tenant.loseChangeModal.button.back" />
          </Button>
          <Button load={load} primary onClick={() => this.onClick(ResetModalClickedValues.Ok)}>
            <FormattedMessage id="setup_tenant.loseChangeModal.button.proceed" />
          </Button>
        </Flex>
      </CustomModal>
    )
  }
}

export default LoseChangesModal
